import React from 'react';

import Wrapper from './styles';

const PageInner = props => <Wrapper {...props} />;

export default PageInner;
